'use client';

import { ChangeEvent, useMemo, useState } from 'react';

import { SvgIconWrapper, TextField, Typography } from 'lighthouse';
import { SearchOutlineMdV2SVG } from 'lighthouse-icons';

import SwipeableDrawer from '@/widgets/SwipeableDrawer';

import { ServiceItem } from '../ServiceItem';
import { AllServicesModalProps } from './models';

export const AllServicesModal = ({ open, onClose, services }: AllServicesModalProps) => {
    const [search, setSearch] = useState('');

    const filteredServices = useMemo(() => {
        const normalizedSearch = search.trim().toLowerCase();

        if (!normalizedSearch) return services;

        return services.filter((service) => service.title.toLowerCase().includes(normalizedSearch));
    }, [search, services]);

    const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSearch(event.target.value);
    };

    const handleClose = () => {
        setSearch('');
        onClose();
    };

    if (!open) return null;

    return (
        <SwipeableDrawer open title='همه خدمات' hasCloseButton onClose={handleClose}>
            <div className='px-4 pb-4 pt-3'>
                <TextField
                    InputProps={{ endAdornment: <SvgIconWrapper icon={SearchOutlineMdV2SVG} size='md' color='blackMediumEmphasis' /> }}
                    value={search}
                    label='جست‌وجوی خدمات'
                    onChange={handleSearchChange}
                    className='w-full'
                />
            </div>
            <div className='max-h-96 overflow-y-auto pb-6'>
                <div className='mt-4 px-4'>
                    {filteredServices.length ? (
                        <div className='grid grid-cols-4 gap-x-3 gap-y-5 md:grid-cols-3'>
                            {filteredServices.map((service) => (
                                <div key={service.id}>
                                    <ServiceItem service={service} />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <Typography variant='body2' className='py-8 text-center' color='blackMediumEmphasis'>
                            خدماتی پیدا نشد
                        </Typography>
                    )}
                </div>
            </div>
        </SwipeableDrawer>
    );
};
